export default "__VITE_ASSET__3a7a1f87__"